import PollDetails from '@/page/poll/tabs/PollDetailTab'
import Home from '@/page/home/Home'
import PollPage from '@/page/poll/PollPage'
import ResultPage from '@/page/result/ResultPage'
import ResultHistoryPage from '@/page/result/ResultHistoryPage'
import PollDetailTab from '@/page/poll/tabs/PollDetailTab'
import LottoRoundsPage from '@/page/game/LottoRoundsPage'
import LottoPage from '@/page/game/LottoPage'
import TicketDetailsPage from '@/page/ticket/TicketDetailsPage'
import { Navigate, RouteObject } from 'react-router'
import Page404 from '@/page/404/404Component'
import LandingPage from '@/page/landing/landing'

const routes: RouteObject[] = [
  { path: '/startGame/:token', element: <LandingPage /> },
  { path: '/session_error', element: <Page404 /> },
  {
    path: '/',
    children: [
      { path: '/', element: <Navigate to="/lotto/" replace /> },
      { path: '404', element: <Page404 /> },
      {
        path: 'ticket_transactions/:transactionId',
        element: <TicketDetailsPage />,
      },
      {
        path: 'lotto',
        children: [
          { path: '', element: <Home /> },
          { path: ':gameType/:gameId', element: <LottoRoundsPage /> },
          { path: ':gameType/:gameId/:roundId', element: <LottoPage /> },
          { path: 'poll', element: <PollPage /> },
          { path: 'poll/history/:betId', element: <PollDetails isHistory /> },
          { path: 'poll/:betId', element: <PollDetailTab /> },
          { path: 'result', element: <ResultPage /> },
          { path: 'result/history/:gameId', element: <ResultHistoryPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/404" replace /> },
]
export default routes
